import { FC, useEffect, useRef, useState } from 'react';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';
import { EU_SITES } from '@/constants/membersday';

interface IProps {
    type?: string;
    list: any[];
}

const Banner: FC<IProps> = ({ list = [] }) => {
    const { locale } = getLocal();
    const [activeId, setActiveId] = useState();
    const isNoneInitH = useRef(true);
    const [fixH, setFixH] = useState(0);
    const tabsContainerRef: any = useRef<HTMLDivElement>();

    const initFnA = () => {
        const bar = document.querySelector('.announcement-bar') as HTMLElement;
        if (bar) {
            const styles = window.getComputedStyle(bar);
            const position = styles.position;
            setFixH(Number(position === 'sticky' ? bar?.offsetHeight : 0) || 0);
            isNoneInitH.current = false;
        }
    };

    useEffect(() => {
        const initFn = () => {
            for (let i = list.length - 1; i >= 0; i--) {
                initItemFn(list[i]);
            }
            if (isNoneInitH.current) {
                initFnA();
            }
        };
        const initItemFn = (item: any) => {
            const elem = document.getElementById(`${item.href}`);
            if (elem) {
                //const clientH = document.documentElement.clientHeight;
                const { top } = elem.getBoundingClientRect();
                const hEnterA = top < 200; //距离顶部200
                const hEnterB = top > -200; //已淡出-200
                if (hEnterA && hEnterB) {
                    setActiveId(item.href);
                    // document.querySelector(`#teaser-nav-common [href='#${item.href}']`)?.classList.add('bar-anchor-item-hover');
                    // const listA = document.querySelectorAll(`#teaser-nav-common :not([href='#${item.href}'])`);
                    // for (let m = 0; m < listA.length; m++) {
                    //     listA[m].classList.remove('bar-anchor-item-hover');
                    // }
                }
            }
        };
        initFnA();
        //initFn(); //执行1次
        window.addEventListener('scroll', initFn);
    }, [list.length]);
    if (list.length === 0) {
        return null;
    }
    return (
        <div
            className={`${styled.Banner} ${EU_SITES.includes(locale) ? ' bar-anchor-eu' : ''} `}
            id="teaser-nav-common"
            style={{
                top: `${fixH}px`,
            }}
        >
            <div className="bar-anchor-in" key={list.length} ref={tabsContainerRef}>
                {list.map((item: any, index: number) => {
                    return (
                        <a
                            className={`bar-anchor-item ${activeId === item.href ? 'bar-anchor-item-hover' : ''}`}
                            key={index}
                            href={`#${item.href}`}
                            onClick={() => {
                                setTimeout(() => {
                                    tabsContainerRef.current.scrollTo({
                                        left: 100 * index,
                                        behavior: 'smooth',
                                    });
                                }, 350);
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'activity_navigation',
                                    navigation_name: item.title,
                                    position: 'Top',
                                });
                            }}
                        >
                            {item.title}
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default Banner;
